import LocalizedStrings from 'react-localization';

export let strings = new LocalizedStrings({
    en: {
        heading: 'Delete conversation',
        paragraph: 'Are you sure you want to delete this conversation?',
        paragraph2: 'Conversation name: ',
        button: {
            text: 'Delete conversation',
            textCancel: 'Cancel',
        }
    },
    es: {
        heading: 'Borrar tema de conversación',
        paragraph: 'Estas seguro de querer borrar el tema de conversación?',
        paragraph2: 'Nombre: ',
        button: {
            text: 'Delete subject',
            textCancel: 'Cancel',
        }
    }
});


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormDeleteIntent/content.js